import React, { useMemo } from 'react'
import { Tag as AntTag } from 'antd'
import { colorHexToRgbWithAlpha } from '@helpers'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { EnrollmentStatus } from '@src/models'

export interface IEmployeeStatus {
  status: string
}

export const EmployeeStatus: React.FC<IEmployeeStatus> = React.memo(
  ({ status }) => {
    const { t } = useTranslation()
    const state = useMemo(
      () =>
        status === EnrollmentStatus.Pending
          ? {
              label: t('signature.admin.usersTemplate.table.states.pending'),
              color: '#ffc887'
            }
          : status === EnrollmentStatus.InProgress
          ? {
              label: t(
                'signature.admin.usersTemplate.table.states.in_progress'
              ),
              color: '#ec5b56'
            }
          : {
              label: t('signature.admin.usersTemplate.table.states.active'),
              color: '#36b37e'
            },
      [status]
    )
    const text = useMemo(() => `${state.label}`, [state])
    return (
      <AntTag
        style={{
          ...colorHexToRgbWithAlpha(state.color, 0.25)
        }}
      >
        <span className={styles.label}>{text}</span>
      </AntTag>
    )
  }
)
